<template>
  <Modal title="学员批量结课" v-model="visible">
    <Form ref="BatchCompletedCoursesForm" class="form"
          :model="batchCompletedCoursesParam"
          :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item label="学员ID" prop="uIds">
            <Input v-model="batchCompletedCoursesParam.uIds" type="textarea" placeholder="id以 ; 拼接"></Input>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="结课类型" prop="completedType">
            <Select v-model.number="batchCompletedCoursesParam.completedType" :transfer="true">
              <Option v-for="item in completedTypeList" :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>


      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingBatchCompletedCourses" @click="batchCompletedCourses">结课
      </Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'BatchCompletedCoursesModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uidStr: {
      type: String,
      default: ''
    },
    successCallback: {
      type: Function
    }
  },
  data() {
    return {
      completedTypeList: [
        {code: 1, text: '无购课记录或无有效订单'},
        {code: 2, text: '课程有效期已到期'},
        {code: 3, text: '课时已完结'}
      ],
      visible: this.value,
      loadingBatchCompletedCourses: false,
      batchCompletedCoursesParam: {
        uIds: '',
        completedType: 0
      },
    }
  },
  methods: {
    batchCompletedCourses() {
      let self = this

      self.loadingBatchCompletedCourses = true
      self.$http.post('/user/overClass/batch', this.batchCompletedCoursesParam).then(function (res) {
        if (res && res.data === 0) {
          self.successCallback()
          self.visible = false
        }
        self.loadingBatchCompletedCourses = false
      }).catch(function (e) {
        self.visible = false
        self.loadingBatchCompletedCourses = false
      })
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible (val) {
      if (val === false) {
        this.batchCompletedCoursesParam.uIds = ''
        this.batchCompletedCoursesParam.completedType = 0
      } else {
        this.batchCompletedCoursesParam.uIds = this.uidStr
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// BatchCompletedCoursesModal.vue?5216b551